import { render, staticRenderFns } from "./Game_Mail.vue?vue&type=template&id=1080ed46&scoped=true&"
import script from "./Game_Mail.vue?vue&type=script&lang=js&"
export * from "./Game_Mail.vue?vue&type=script&lang=js&"
import style0 from "./Game_Mail.vue?vue&type=style&index=0&id=1080ed46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1080ed46",
  null
  
)

export default component.exports